<template>
    <MaskLayout :isShow="isShow" @closeMask="closeMask" :contentStyle="wrapStyle">
        <div class="page-relative add-coupon-wrap">
            <p class="page-text-center page-margin-top3 title">添加卡券</p>
            <form class="movie-wrapper coupon-text" @submit.prevent="submit">
                <div class="item">
                    <div class="acea-row row-between-wrapper">
                    <label for="">账号：</label>
                    <input
                        class="page-flex-1"
                        type="text"
                        placeholder="请输入账号"
                        v-model="account"
                        required
                    />
                    </div>
                </div>
                <div class="item">
                    <div class="acea-row row-between-wrapper">
                    <label for="">密码：</label>
                    <input
                        class="page-flex-1"
                        type="password"
                        placeholder="请输入密码"
                        v-model="password"
                        required
                    />
                    </div>
                </div>
            </form>
            <div class="logon" @click="submit">添加</div>
            <div class="page-absolute close" @click="closeMask(false)">×</div>
        </div>
    </MaskLayout>
</template>

<script>
import MaskLayout from "@components/MaskLayout.vue";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { addCouponFn, QueryCouponFn } from "@api/user";
export default {
    name: "AddCoupon",
    components: {
        MaskLayout
    },
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        currentCoupon: {
            type: String,
            default: ""
        }
    },
    data: function() {
        return {
            wrapStyle: {
                "top": "30%",
                "left": "50%",
                "transform": "translate(-50%,0)",
                "width": "80%",
                "height": "4.5rem",
                "border-radius": ".3rem"
            },
            account: "",
            password: "",
            couponArray: [
                { minCoupon: "80020684", maxCoupon: "80020687"},
                { minCoupon: "80016562", maxCoupon: "80016640"},
                { minCoupon: "80018328", maxCoupon: "80020676"},
                { minCoupon: "80021188", maxCoupon: "80021191"},
                { minCoupon: "80020830", maxCoupon: "80021061"}
            ],
        }
    },
    watch: {
        isShow: function (newVal, oldVal) {
            if (newVal) {
                this.account = "";
                this.password = "";
            }
        }
    },
    methods: {
        closeMask: function (val) {
            this.$emit("closeMask", val);
        },
        async submit() {
        let { account, password } = this;
        account = account.trim();
        password = password.trim();
        if (!account || !password) this.$message.error("请输入完整");
        try {
            this.$validator({
            account: [
                required(required.message("账号")),
                attrs.range([5, 16], attrs.range.message("账号")),
                alpha_num(alpha_num.message("账号"))
            ],
            password: [
                required(required.message("密码")),
                attrs.range([6, 16], attrs.range.message("密码")),
                alpha_num(alpha_num.message("密码"))
            ]
            }).validate({ account, password });
        } catch (e) {
            return validatorDefaultCatch(e);
        }

        let isFalse = false;
        for(let i = 0; i<this.couponArray.length; i++) {
          if (account >= this.couponArray[i].minCoupon && account <= this.couponArray[i].maxCoupon) {
            isFalse = true;
          }
        }

        if (isFalse && account != this.currentCoupon) {
              this.add();
            } else {
                this.$dialog.error("此号已为登录账号，请添加其他卡券");
            }
        },
        add() {
            let { account, password } = this;
            account = account.trim();
            password = password.trim();
            let data = {
                account, password
            };

            QueryCouponFn(data).then((res)=>{
                
                if (res.status == 200) {
                    let current = res && res.data && res.data.couponData;
                    let bind = res && res.data && res.data.bindCouponData;
                    let card_one = {//当前
                        title: current.title,
                        yue: current.now_money,
                        update: current.update_money
                    };
                    let card_two = {//绑定
                        title: bind.title,
                        yue: bind.now_money,
                        update: bind.update_money
                    };

                    this.$dialog.confirm({
                    mes: `此操作将 \r\n 账号: ${card_two.title} 余额：${card_two.yue}点 \r\n 转出充值到 \r\n 账号：${card_one.title}  余额：${card_one.yue}点 \r\n 转出充值后 \r\n 账号${card_two.title} 余额：${card_two.update}点 \r\n 账号${card_one.title} 余额：${card_one.update}点 `,
                    opts: () => {

                        addCouponFn(data).then((res)=>{
                            // console.log(res, "res添加卡");
                            this.$dialog.success(res.msg);
                            this.$emit('success');
                            let line = setTimeout(()=>{
                                this.closeMask(false);
                                clearTimeout(line);
                            }, 1000);

                        }).catch(err=>{
                            // console.log(err);
                            this.$dialog.error(err.msg);
                        });
                    }
                })

                } else {
                    this.$dialog.error(res.msg);
                }
                
            }).catch((err)=>{
                // console.log(err);
                this.$dialog.error(err.msg);
            })
        }
    }
}
</script>

<style scoped>
.add-coupon-wrap {}
.title {
    font-size: .36rem;
    font-weight: 600;
}
.coupon-text {
    margin-top: .3rem;
}
.item {
    margin-top: .1rem;
}
.item > div{
    width: 100%;
    height: .82rem;
    font-size: .34rem;
}
.item  label {
    margin-right: .2rem;
    margin-left: .1rem;
}
.logon {
    width: 3rem;
    height: .7rem;
    font-size: .34rem;
    background: #e83323;
    color: #fff;
    border-radius: .1rem;
    text-align: center;
    line-height: .7rem;
    margin: .35rem auto 0;
}
.close {
    font-size: .3rem;
    width: .4rem;
    height: .4rem;
    text-align: center;
    line-height: .4rem;
    border-radius: 50%;
    border: .02rem solid #999;
    top: -0.1rem;
    right: .2rem;
}
</style>